// extracted by css-extract-rspack-plugin
export default {"pureLink":"recommendation-fragment__PureLink_pureLink__G0LVq"};